import MainContainer from "../../components/MainContainer";
import { headerDataImmo } from "../../data/modules/logistic-header";
import { makeStyles } from "@material-ui/core/styles";
import { useState, useEffect, useContext } from "react";

import { Grid, Paper } from "@material-ui/core";
import { Button } from "@material-ui/core";
import Spacer from "../../components/Spacer";
import InventoryToStock from "./InventoryToStock";
import InventoryAffectation from "./InventoryAffectation";
import InventoryValidation from "./InventoryValidation";
import ExportExcel from "./ExportExcel";
import InventoryService from "../../services/InventoryService";
import UserService from "../../services/UserService";
import ImmobilisationService from "../../services/ImmobilisationService";
import FilterValidation from "../../components/FilterValidation";
import TransferedTable from "./TransferedTable";
const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 0,
  },
  style1: {
    fontSize: "5em",
  },
}));
export default function TransferedList() {
  const classes = useStyles();
  var myCurrentDate = new Date();

  //console.log("currentDAte", myCurrentDate);
  //console.log("immo list : ",localStorage.getItem("immoArrayStorage"));

  var date =
    myCurrentDate.getFullYear() +
    "-" +
    (myCurrentDate.getMonth() + 1) +
    "-" +
    myCurrentDate.getDate()+
    "-" +
    myCurrentDate.getHours()+
    "-" +
    myCurrentDate.getMinutes()+
    "-" +
    myCurrentDate.getSeconds();

  const [dataToExport, setDataToExport] = useState([]);
  const [dataDetenteurExport, setdataDetenteurExport] = useState([]);
  const [dataImmo, setDataImmo] = useState([]);
  const [rows, setRows] = useState([]);
  const [fileName, setFileName] = useState("Inventaire enregistré le " + date);
  const [filenameDetenteur, setfilenameDetenteur] = useState("detenteur_immo_" + date);
  const [isOpenStock, setIsOpenStock] = useState(false);
  const [isOpenAffectedTo, setIsOpenAffectedTo] = useState(false);
  const [isOpenFirstValidation, setIsFirstValidation] = useState(false);

  const wscols = [
    { wch: 25 },
    { wch: 25 },
    { wch: 45 },
    { wch: 15 },
    { wch: 25 },
    { wch: 25 },
    { wch: 45 },
    { wch: 10 },
    { wch: 25 },
  ];

  const wscolsDetenteur = [
    { wch: 25 },
    { wch: 25 },
    { wch: 45 },
    { wch: 45 },
    { wch: 10 },
    { wch: 10 },
    { wch: 10 },
  ];

  useEffect(() => {
    InventoryService.exportExcel().then((result) => {
      if (result && result.data) {
        setDataToExport(result.data);
      }
    });
    InventoryService.exportDetenteurExcel().then((result) => {
      if (result && result.data) {
        setdataDetenteurExport(result.data);
      }
    });

  }, []);
  
  function handleClickStock() {
    var allImmoSelected = localStorage.getItem("immoArrayStorage");
    console.log("xhr : ", allImmoSelected);
    ImmobilisationService.getAllSelectedCodeImmo(allImmoSelected).then((result) => {
      if (result && result.data) {
        setDataImmo(result.data);
      }
    });
    setIsOpenStock(true);
  }
  
  function handleCloseDialogStock() {
    setIsOpenStock(false);
  }
  
  function handleClickAffectedTo() {
    var allImmoSelected = localStorage.getItem("immoArrayStorage");
    ImmobilisationService.getAllSelectedCodeImmo(allImmoSelected).then((result) => {
      if (result && result.data) {
        setDataImmo(result.data);
      }
    });
    UserService.getAllUserActive().then((result) => {
      if (result && result.data) {
        setRows(result.data.map((row) => ({ ...row, id: row.user_id })));
      } 
    });
    setIsOpenAffectedTo(true);
  }
  const handleSubmit = (e) => {
    window.location.reload();

  };
  const Refresh = (e) => {
    e.preventDefault();
      localStorage.removeItem('name_materiel');
      localStorage.removeItem('code_immo');
      localStorage.removeItem('state');
      localStorage.removeItem('logistics_manager');
      localStorage.removeItem('status1');
      localStorage.removeItem('status2');
      localStorage.setItem('name_materiel',"");
      localStorage.setItem('code_immo',"");
      localStorage.setItem('state',"");
      localStorage.setItem('logistics_manager',"");
      localStorage.setItem('status1',"");
      localStorage.setItem('status2',"");
      
      window.location.reload()
  };
  function handleClickValidatedTo() {
    var allImmoSelected = localStorage.getItem("immoArrayStorage");
    ImmobilisationService.getAllSelectedCodeImmo(allImmoSelected).then((result) => {
      if (result && result.data) {
        setDataImmo(result.data);
      }
    });
    setIsFirstValidation(true);
  }

  function handleCloseDialogAffectedTo() {
    setIsOpenAffectedTo(false);
  }

  function handleCloseDialogValidation() {
    setIsFirstValidation(false);
  }

  return (
    <MainContainer {...headerDataImmo}>
      <Grid container item xs={12}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleClickStock}
          style={{ fontWeight: 600 }}
        >
          CLASSEMENT EN STOCK
        </Button>
        <Spacer x={2} />

        <Button
          variant="contained"
          color="primary"
          onClick={handleClickValidatedTo}
          style={{ fontWeight: 600, backgroundColor:"green", color:"#FFFFFF" }}
        >
          VALIDER LE TRANSFERT
        </Button>
        <Spacer x={2} />
        <Button
                  variant="contained"
                  onClick={Refresh}
                  style={{ fontWeight: 600, backgroundColor:'darkred', color:'white'}}
                >
                  réinitialiser le filtre
                </Button>
                <Spacer x={2} />
                <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                style={{ fontWeight: 600} }
              >
                Filtrer
              </Button>
        <Spacer x={2} />
        <FilterValidation type={1} />
        <ExportExcel
          dataToExport={dataToExport}
          dataDetenteurExport={dataDetenteurExport}
          filenameHistory={fileName}
          filenameDetenteur={filenameDetenteur}
          style={classes.style1}
          wscols={wscols}
          wscolsDetenteur={wscolsDetenteur}
        />

        <InventoryToStock
          dataImmo={dataImmo}
          open={isOpenStock}
          closeDialog={handleCloseDialogStock}
        />

        <InventoryAffectation
          dataImmo={dataImmo}
          rows={rows}
          open={isOpenAffectedTo}
          closeDialog={handleCloseDialogAffectedTo}
          fullWidth
          maxWidth="sm"
        />

        <InventoryValidation
          isAffecation={true}
          dataImmo={dataImmo}
          open={isOpenFirstValidation}
          closeDialog={handleCloseDialogValidation}
        />
      
      </Grid>
    

      <Spacer y={2} />
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper className={classes.paper} variant="outlined">
            <TransferedTable />
          </Paper>
        </Grid>
      </Grid>
      
    </MainContainer>
  );
}
